
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')
require('./messages')

window.Vue = require('vue')

import VeeValidate, { Validator } from 'vee-validate'
import es from 'vee-validate/dist/locale/es'
import vSelect from 'vue-select'
import Vuesax from 'vuesax';
import VModal from 'vue-js-modal'
import VuePrism from 'vue-prism'
import Tabs from 'vue-tabs-component'
import vueSmoothScroll from 'vue-smooth-scroll'
import VueGoodTable from 'vue-good-table'
import VueAutosize from 'vue-autosize'
import { Money } from 'v-money'
import VueTheMask from 'vue-the-mask'
//import DatePicker from 'vue2-datepicker'
import Cleave from 'vue-cleave-component'
import Loader from './components/element/Loader.vue'
import VueI18n from 'vue-i18n'
import "vuesax/dist/vuesax.css";
import 'material-icons/iconfont/material-icons.css';

Validator.localize('es', es);

/// Init
Vue.use(VeeValidate)
Vue.use(VModal)
Vue.use(VuePrism)
Vue.use(Tabs)
Vue.use(VueGoodTable)
Vue.use(Cleave)
Vue.use(VueTheMask)
Vue.use(vueSmoothScroll)
Vue.use(VueAutosize)
Vue.use(Vuesax, {
    // options here
});
Vue.use(VueI18n)
//Vue.use(DatePicker)

/// Componentes
Vue.component('v-select', vSelect)
Vue.component('money', Money)
Vue.component('input-field', require('./components/element/InputField.vue'))
Vue.component("dynamicTable", require("./components/element/DynamicTable.vue"));
Vue.component('textarea-field', require('./components/element/TextareaField.vue'))
Vue.component('dropdown', require('./components/element/Dropdown.vue'))
Vue.component('dropdown-notification', require('./components/element/DropdownNotification.vue'))
Vue.component('notification', require('./components/element/Notification.vue'))
Vue.component('loader', Loader)
Vue.component('kTable', require('./components/element/KTable.vue'))
Vue.component('datePicker', require('./components/element/DatePicker.vue'))
Vue.component('checkedListbox', require('./components/element/CheckedListbox.vue'))
Vue.component('tableBar', require('./components/element/TableBar.vue'))

Vue.component('dashboard', require('./components/forms/Dashboard.vue'))
Vue.component('itemDashboard', require('./components/forms/ItemDashboard.vue'))

/// Layout
Vue.component('kp-header', require('./components/layout/Header.vue'))
Vue.component('kp-logo', require('./components/layout/Logo.vue'))
Vue.component('kp-menu', require('./components/layout/menu/MainMenu.vue'))
Vue.component('kp-submenu', require('./components/layout/menu/Submenu.vue'))
Vue.component('kp-support', require('./components/layout/Support.vue'))
Vue.component('kp-user', require('./components/layout/UserStatus.vue'))
Vue.component('menu-search', require('./components/layout/menu/Search.vue'))

//Clientes
Vue.component('consultaContenedores', require('./components/forms/clientes/ConsultaContenedores.vue'))
Vue.component('itemContenedor', require('./components/forms/clientes/ItemContenedor.vue'))
Vue.component('itemGrupoContenedor', require('./components/forms/clientes/ItemGrupoContenedor.vue'))
Vue.component('visorImagen', require('./components/forms/clientes/VisorImagen.vue'))
Vue.component('enviarEir', require('./components/forms/clientes/EnviarEir.vue'))

//Reparaciones
Vue.component('listaReparaciones', require('./components/forms/reparaciones/ListaReparaciones.vue'))
Vue.component('reparacion', require('./components/forms/reparaciones/Reparacion.vue'))

//Tpis
Vue.component('listaTpis', require('./components/forms/tpis/ListaTpis.vue'))
Vue.component('tpi', require('./components/forms/tpis/Tpi.vue'))

Vue.component('booking', require('./components/forms/Booking.vue'))
Vue.component('consultaHistorico', require('./components/forms/ConsultaHistorico.vue'))
Vue.component('edicionHistorico', require('./components/forms/EdicionHistorico.vue'))
Vue.component('consultaEdis', require('./components/forms/ConsultaEdis.vue'))


//Modos
Vue.component('listaModos', require('./components/forms/modos/ListaModos.vue'))
Vue.component('modo', require('./components/forms/modos/Modo.vue'))

//Materiales
Vue.component('listaMateriales', require('./components/forms/materiales/ListaMateriales.vue'))
Vue.component('material', require('./components/forms/materiales/Material.vue'))

//Inspecciones
Vue.component('consultaInspecciones', require('./components/forms/inspeccion/ConsultaInspecciones.vue'))
Vue.component('itemInspeccion', require('./components/forms/inspeccion/ItemInspeccion.vue'))
Vue.component('notificacionProceso', require('./components/forms/inspeccion/NotificacionProceso.vue'))
Vue.component('reporteLogs', require('./components/forms/inspeccion/ReporteLogs.vue'))

//Sts
Vue.component('listaSts', require('./components/forms/sts/ListaSts.vue'))
Vue.component('sts', require('./components/forms/sts/Sts.vue'))
Vue.component('tablaAreas', require('./components/forms/sts/TablaAreas.vue'))
Vue.component('trArea', require('./components/forms/sts/TrArea.vue'))

Vue.component('listaTiposUnidad', require('./components/forms/tipos-unidad/ListaTiposUnidad.vue'))
Vue.component('tipoUnidad', require('./components/forms/tipos-unidad/TipoUnidad.vue'))

Vue.component('listaStowage', require('./components/forms/stowage/ListaStowage.vue'))
Vue.component('stowage', require('./components/forms/stowage/Stowage.vue'))

Vue.component('listaRemarks', require('./components/forms/remarks/ListaRemarks.vue'))
Vue.component('remark', require('./components/forms/remarks/Remark.vue'))
//Localizaciones
Vue.component('listaLocalizaciones', require('./components/forms/localizaciones/ListaLocalizaciones.vue'))
Vue.component('localizacion', require('./components/forms/localizaciones/Localizacion.vue'))

//Ecas y Coparn
Vue.component('consultaEcas', require('./components/forms/ecas-coparn/ConsultaEcas.vue'))
Vue.component('ecas', require('./components/forms/ecas-coparn/Ecas.vue'))
Vue.component('consultaCoparn', require('./components/forms/ecas-coparn/ConsultaCoparn.vue'))
Vue.component('coparn', require('./components/forms/ecas-coparn/Coparn.vue'))
Vue.component('logNoProcesados', require('./components/forms/ecas-coparn/LogNoProcesados.vue'))
Vue.component('logsEcasCoparn', require('./components/forms/ecas-coparn/LogsEcasCoparn.vue'))

// Propiedades
Vue.component('editarUnidad', require('./components/forms/sistema/EditarUnidad.vue'))
Vue.component('atajos', require('./components/forms/sistema/Atajos.vue'))

// Reportes
Vue.component('reporteGeneral', require('./components/forms/reportes/ReporteGeneral.vue'))
Vue.component('reporteUpdated', require('./components/forms/reportes/ReporteUpdated.vue'))

//Plantillas
Vue.component('plantilla', require('./components/forms/plantillas/Plantilla.vue'))

//Logs Api Reverse
Vue.component('logsApiReverse', require('./components/forms/LogsApiReverse.vue'));

Vue.component('listadoPatiosDefecto', require('./components/forms/ListadoPatiosDefecto.vue'));

Vue.component('tablaParametrosCliente', require('./components/forms/clientes/TablaParametrosCliente.vue'));
Vue.component('parametrosEnvioRecepcion', require('./components/forms/clientes/ParametrosEnvioRecepcion.vue'));

Vue.component('auditoriaPropiedad', require('./components/forms/AuditoriaPropiedad.vue'));

Vue.component('tablaSellos', require('./components/forms/clientes/TablaSellos.vue'));

Vue.component('logsCodeco', require('./components/forms/LogsCodeco.vue'));

axios.interceptors.request.use(function (config) {
    let id = uuid();
    let Modal = Vue.extend(Loader);
    let ModalComponent = new Modal({
        propsData: {
            name: id,
            loading: true
        }
    }).$mount();
    app.$refs.app.appendChild(ModalComponent.$el);
    config.component = ModalComponent;
    config.id = id;
    app.$modal.show(id);
    return config;
}, function (error) {
    app.$modal.hide(error.config.id);
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    app.$modal.hide(response.config.id);
    app.$refs.app.removeChild(response.config.component.$el);
    return response;
}, function (error) {
    app.$modal.hide(error.config.id);
    app.$refs.app.removeChild(error.response.config.component.$el);
    return Promise.reject(error);
});

const i18n = new VueI18n({
    locale: language,
    messages
});

const app = new Vue({
    i18n
})
app.$mount('#app')
window.app = app;


// WEBPACK FOOTER //
// ./resources/assets/js/app.js